import React from 'react';

import { Button, Stack } from '@lyearn/ui';
import { CreatePostMeta } from '@/types/schema';

function TeachModeFollowUps({
  onClickFollowUp,
}: {
  onClickFollowUp: (value: string, meta?: CreatePostMeta) => void;
}) {
  const handleSummarize = () => {
    const meta: CreatePostMeta = {
      summarize: true,
    };
    onClickFollowUp('Summarize', meta);
  };
  const handleCreateDoc = () => {
    const meta: CreatePostMeta = {
      createKnowledgeDoc: true,
    };
    onClickFollowUp('Create a knowledge doc', meta);
  };

  return (
    <Stack
      alignItems="center"
      className="w-full mt-8"
      direction="row"
      gap={8}
      justifyContent="start">
      <Button appearance="secondary" size="small" variant="outlined" onClick={handleSummarize}>
        Summarize
      </Button>
      <Button appearance="secondary" size="small" variant="outlined" onClick={handleCreateDoc}>
        Create a knowledge doc
      </Button>
    </Stack>
  );
}

export default React.memo(TeachModeFollowUps);
